import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Support from "@/pages/Support";
import GroupInvite from "@/pages/GroupInvite";
import StoreRedirect from "@/pages/StoreRedirect";
import { STORE_REDIRECTS } from "@/lib/storeRedirects";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/groups/:code" element={<GroupInvite />} />
          {Object.keys(STORE_REDIRECTS).map((p) => (
            <Route key={p} path={`/${p}`} element={<StoreRedirect />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
